const TEACHER_TOKEN_KEY = "docen_teacher_access_token";
const ADMIN_TOKEN_KEY = "docen_admin_access_token";

export function getTeacherToken() {
    return localStorage.getItem(TEACHER_TOKEN_KEY);
}

export function setTeacherToken(token) {
    if (token) localStorage.setItem(TEACHER_TOKEN_KEY, token);
}

export function clearTeacherToken() {
    localStorage.removeItem(TEACHER_TOKEN_KEY);
}

export function getAdminToken() {
    return localStorage.getItem(ADMIN_TOKEN_KEY);
}

export function setAdminToken(token) {
    if (token) localStorage.setItem(ADMIN_TOKEN_KEY, token);
}

export function clearAdminToken() {
    localStorage.removeItem(ADMIN_TOKEN_KEY);
}
